// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"157":"9c363348","508":"fb3a724e","654":"4bf83e75","919":"d637a7b5"}[chunkId] + ".chunk.css";
};